export default __webpack_public_path__ + "static/media/pokemon_rock.55ac375f.png";